import imageProperties from '../lib/image-properties'

const createQuery = () => `
  ... on ImageGridWidget {
    imageGridItems: images {
      title
      alt
      credits
      images {
        grid_griditem_320 {
          ${imageProperties}
        }
        grid_griditem_640 {
          ${imageProperties}
        }
        grid_griditem_960 {
          ${imageProperties}
        }
        grid_griditem_1280 {
          ${imageProperties}\
        }
      }
    }
  }
`

export default createQuery
